import styles from "./theming-sub-header-container.less";

type ThemingSubHeaderContainerProps = {
    description: string;
};

export const ThemingSubHeaderContainer = (props: ThemingSubHeaderContainerProps) => {
    const { description } = props;

    return (
        <div className={styles.themingSubHeaderContainer}>
            <span>{description}</span>
        </div>
    );
};